import { api } from '../utils/axios';

export const requestCastUrl = (cast_key, kasm_url, docker_network, recaptcha_value, referrer) => async (dispatch) => {
  
  let data = {'cast_key': cast_key, 'recaptcha_value': recaptcha_value, 'referrer': referrer, 'kasm_url': kasm_url, 'docker_network' : docker_network, 'x_res': window.innerWidth, 'y_res': window.innerHeight};
  dispatch({
    type: "REQUEST_CAST_REQUESTED"
  });
  try {
    const response = await api.post('request_cast', data);
    dispatch({
      type: "REQUEST_CAST_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "REQUEST_CAST_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getCastConfigs = () => async (dispatch) => {
  
  let data = {};
  dispatch({
    type: "GET_CAST_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_cast_configs', data);
    dispatch({
      type: "GET_CAST_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_CAST_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export function setCastPageInfo({pageSize,pageNo}){
  return {
    type : 'SET_CAST_PAGEINFO',
    payload : {pageSize,pageNo }
  }
}

export const deleteCastConfig = (cast_config_id) => async (dispatch) => {
  
  let data = {cast_config_id: cast_config_id};
  dispatch({
    type: "DELETE_CAST_REQUESTED"
  });
  try {
    const response = await api.post('admin/delete_cast_config', data);
    dispatch({
      type: "DELETE_CAST_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DELETE_CAST_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const createCastConfig = (cast_config) => async (dispatch) => {
  
  let data = {};
  data.target_cast_config = cast_config;
  dispatch({
    type: "CREATE_CAST_REQUESTED"
  });
  try {
    const response = await api.post('admin/create_cast_config', data);
    dispatch({
      type: "CREATE_CAST_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CREATE_CAST_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updateCastConfig = (cast_config) => async (dispatch) => {
  
  let data = {};
  data.target_cast_config = cast_config;
  dispatch({
    type: "UPDATE_CAST_REQUESTED"
  });
  try {
    const response = await api.post('admin/update_cast_config', data);
    dispatch({
      type: "UPDATE_CAST_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_CAST_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}
